export default {
  props: {
    value: {},
    disabled: {default: false}
  },
  data() {
    return {
      word: '',

      deleteDialog: false,
      structureDialog: false,

      filteredData: [],
      models: [],

      currentPage: 1,

      modelsQty: 0,
      pageQty: 0,

      multipleSelection: undefined,

      listStructure: {}
    }
  },
  created() {
    this.models = this.value;
  },
  methods: {
    updateStructure() {
      this.structureDialog = false;
    },
    getModelCaption(modelKey, id) {
      let caption = '-';
      if (modelKey === id)
        caption = ''; //AMIN
      // window.actions.callService('qasedak', 'GetModelCaption', {
      //   modelKey: modelKey,
      //   modelId: id
      // }).then((res) => {
      //   caption = res.caption;
      // }); //AMIN
      return caption;
    },
    getDate(date) {
      return date;//window.moment(date, 'YYYY/M/D HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    inspectData() {
      let filterKey = this.word && this.word.toLowerCase();
      let data = this.models;

      if (filterKey) {
        data = this.models.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        });
      }

      this.filteredData = data;
    },
    getPermissions(permission) {
      if (!this.listStructure)
        return false;

      if (!this.listStructure.permissions)
        return false;

      return this.listStructure.permissions.indexOf(permission) !== -1;
    },
  },
  computed: {
    searchStyle() {
      const ret = {};
      if (this.$isRtl)
        ret.marginRight = '5px';
      else
        ret.marginLeft = '5px';

      ret.width = '400px';
      return ret;
    },
    firstButtonStyle() {
      const ret = {};
      if (this.$isRtl)
        ret.marginRight = '0';
      else
        ret.marginLeft = '0';
      return ret;
    },
    hasSelection() {
      if (!this.multipleSelection)
        return false;
      return this.multipleSelection.length > 0;
    },
    rangeRules() {
      let rules = {};
      if (!this.limitationStructure)
        return rules;
      for (let f in this.limitationStructure.properties) {
        let _field = this.limitationStructure.properties[f];
        let _rules = _field.rules;
        let fieldRules = [];
        for (let r in _rules) {
          fieldRules.push(_rules[r])
        }

        rules[_field.model] = fieldRules;
      }
      return rules;
    }

  },
  watch: {
    models() {
      this.$emit('input', this.models);
      this.filteredData = this.models;
    },
    value() {
      this.models = this.value;
    },
    word() {
      this.inspectData();
    }
  },
};
